import { render, staticRenderFns } from "./Ceiling.vue?vue&type=template&id=6cf09f6a&scoped=true"
import script from "./Ceiling.vue?vue&type=script&lang=js"
export * from "./Ceiling.vue?vue&type=script&lang=js"
import style0 from "./Ceiling.vue?vue&type=style&index=0&id=6cf09f6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf09f6a",
  null
  
)

export default component.exports